import { useTranslation } from 'react-i18next';
import TabBarMenuMeetingTopicTake from "./tabBarMenuMeetingTopicTake";
import MeetingStructuredQuestionsSection from './MeetingStructuredQuestionsSection';
import MeetingPaceSection from "./meetingPaceSection";
import { TopicTakeSection } from "./TopicTakeSection"
import { useStoreState, useStoreActions } from 'easy-peasy'
import { MeetingObjectivesSection } from "../../apps/meetings/components/meeting-details/MeetingObjectivesSection";
import { useDirectReportee } from "../../apps/meetings/hooks/useDirectReportee";
import { useFetchOneOnOneObjectives } from "../../apps/meetings/hooks/useFetchOneOnOneObjectives";
import { CONVERSATION_STATUS, showPaceCheckIn } from "../../apps/meetings/models/meeting";

// meeting wrapper
const MainDetailsMeetingWrapper = props => {
  const {
    meeting,
    saveMeetingTopic,
    saveMeetingTakeAway,
    currentUser,
    editTopicArea,
    showTopicDescEdit,
    deleteTopicTakeNonTake,
    saveTags,
    updateTopicTake,
    shareMeetingTopic,
    mentionsUserData,
    sortItemNotes,
    sortTakeNotes,
    saveMeetingNullTopicNote,
    deleteTopicAttach,
    deleteNoteAttach,
    addTopicAttach,
    addNoteAttach,
    userPermission,
    updateTopicAttach,
    updateNoteAttach,
    meeting_invitees
   } = props;
   const { t } = useTranslation();

  const { 
    loadingDirectReportee,
    directReporteeId,
    managerId
  } = useDirectReportee({ attendees: meeting_invitees, userId: currentUser.id, isOneOnOne: true });
  
  const { 
    loadingDirectReporteeObjectives,
    response 
  } = useFetchOneOnOneObjectives({ 
    loadingDirectReportee, 
    directReporteeId,
    managerId
  });

   const { 
    showPace, 
    isConversationMeetingCompleted, 
    isConversationMeeting, 
    conversationMeeting, 
    isConversationMeetingClosedByHr,
    isConversationMeetingNotRequired,
    conversationStatus,
  } = useStoreState((state) => state.currentMeeting);

  const { setConversationMeetingPaceRatings } = useStoreActions(
    (actions) => actions.currentMeeting
  );

  const isShowLastAiIcon = props.show_last_ai_icon;

  const goalModule = userPermission.goal || false;

  const paceCheckIn = showPaceCheckIn(conversationMeeting?.meetingTemplateOptions?.paceRatings, conversationMeeting)

  const showStructuredQuestions = Boolean(
    isConversationMeeting
    && conversationMeeting?.hasQuestionnaire
    && window.wbConfig?.structuredReviewQuestionsEnabled
  );
  const structuredQuestionsLocked = isConversationMeetingCompleted
    || isConversationMeetingClosedByHr
    || isConversationMeetingNotRequired;

  return (
    <div className="oneonone-wrapper meeting-wrapper-div-3652">
      { isConversationMeeting && paceCheckIn && (
        <div className="oneononebox pace" style={{ marginBottom: "7px" }}>
          <MeetingPaceSection key={meeting.id}
            isConversationMeeting={isConversationMeeting}
            conversationMeeting={conversationMeeting}
            isConversationMeetingCompleted={isConversationMeetingCompleted || isConversationMeetingClosedByHr || (isConversationMeetingNotRequired && conversationStatus !== CONVERSATION_STATUS.IN_PROGRESS) }
            setConversationMeetingPaceRatings={setConversationMeetingPaceRatings}
            {...props}
          />
        </div>
      )}
      {(meeting.type == "1") ? (
        <div>
          {(showPace && (
            <div className="oneononebox pace" style={{ marginBottom: "7px" }}>
              <MeetingPaceSection key={meeting.id} setConversationMeetingPaceRatings={setConversationMeetingPaceRatings} {...props}/>
            </div>
          ))}
          {(goalModule && (props.objectives.owner.length || props.objectives.user.length)) ? (
            <>
              <div className="clear" />
              <div className="oneononebox">
                <MeetingObjectivesSection
                  isLoadingData={loadingDirectReporteeObjectives}
                  response={response} 
                  directReporteeId={directReporteeId}
                  meeting={props.meeting}
                  currentUser={props.currentUser}
                  selectedUser={props.selectedUser}
                  label={t('Objectives')}
                  type='team'
                  isOneOnOne={true}
                />
              </div>
            </>
          ) : (
            ""
          )}
          <div className="clear" />
        </div>
      ) : (
        ""
      )}
      {showStructuredQuestions && (
        <div className="oneononebox" style={{ marginBottom: '7px' }}>
          <MeetingStructuredQuestionsSection
            key={meeting.id}
            meetingId={meeting.id}
            locked={structuredQuestionsLocked}
          />
        </div>
      )}
      {
        <TabBarMenuMeetingTopicTake
          isShowLastAiIcon={isShowLastAiIcon}
          meetingObj={meeting}
          currentUser={currentUser}
          userPermission={props.userPermission}
          actions={props.actions}
          vg_1on1={props.vg_1on1}
          boxApiKey={props.boxApiKey}
          dropBoxApiKey={props.dropBoxApiKey}
          refreshLegacyData={props.refreshLegacyData}
          accessToken={props.accessToken}
          appInID={props.appInID}
          isFUSEnabled={props.isFUSEnabled}
          deleteTopicTakeNonTake={props.deleteTopicTakeNonTake}
          isConversationMeetingCompleted={isConversationMeetingCompleted}
          isConversationMeetingClosedByHr={isConversationMeetingClosedByHr}
          isConversationMeetingNotRequired={isConversationMeetingNotRequired}
          conversationStatus={conversationStatus}
          msAppId={props.msAppId}
          meetingRedirectUrl={props.meetingRedirectUrl}
        />
      }
      <TopicTakeSection
        {...props}
        saveMeetingTopic={saveMeetingTopic}
        saveMeetingTakeAway={saveMeetingTakeAway}
        currentUser={currentUser}
        editTopicArea={editTopicArea}
        showTopicDescEdit={showTopicDescEdit}
        saveTags={saveTags}
        updateTopicTake={updateTopicTake}
        shareMeetingTopic={shareMeetingTopic}
        mentionsUserData={mentionsUserData}
        sortItemNotes={sortItemNotes}
        saveMeetingNullTopicNote={saveMeetingNullTopicNote}
        sortTakeNotes={sortTakeNotes}
        deleteTopicAttach={deleteTopicAttach}
        deleteNoteAttach={deleteNoteAttach}
        addTopicAttach={addTopicAttach}
        addNoteAttach={addNoteAttach}
        actions={props.actions}
        clearGlobalValue={props.clearGlobalValue}
        tempVar={props.tempVar}
        takeTopicId={props.takeTopicId}
        emptyGlobalTag={props.emptyGlobalTag}
        disabledDoneBtn={props.disabledDoneBtn}
        clearGlobalValueBta={props.clearGlobalValueBta}
        resetTopicTag={props.resetTopicTag}
        deleteTopicTakeNonTake={deleteTopicTakeNonTake}
        saveTakeawayAsAi={props.saveTakeawayAsAi}
        resetMeetingTakesForSmartWobo={props.resetMeetingTakesForSmartWobo}
        accessToken={props.accessToken}
        appInID={props.appInID}
        isFUSEnabled={props.isFUSEnabled}
        updateTopicAttach={updateTopicAttach}
        updateNoteAttach={updateNoteAttach}
        isConversationMeetingCompleted={isConversationMeetingCompleted}
        isConversationMeetingClosedByHr={isConversationMeetingClosedByHr}
        isConversationMeetingNotRequired={isConversationMeetingNotRequired}
        conversationStatus={conversationStatus}
      />
    </div>
  );
};
export default MainDetailsMeetingWrapper;
